import React, { useEffect, useState } from 'react';
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        const newSeconds = prevTime.seconds - 1;
        const newMinutes = newSeconds < 0 ? prevTime.minutes - 1 : prevTime.minutes;
        const newHours = newMinutes < 0 ? prevTime.hours - 1 : prevTime.hours;
        return {
          hours: newHours < 0 ? 23 : newHours,
          minutes: newMinutes < 0 ? 59 : newMinutes,
          seconds: newSeconds < 0 ? 59 : newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-red-50 border-2 border-red-200 p-4 rounded-lg shadow-md mb-6" data-id="element-52">
      <p className="text-center text-red-600 font-bold mb-2" data-id="element-53">
        LIMITED TIME OFFER ENDS IN:
      </p>
      <div className="flex justify-center gap-2 text-center" data-id="element-54">
        <div className="bg-red-600 text-white p-2 rounded-lg w-20 shadow-sm" data-id="element-55">
          <div className="text-3xl font-bold" data-id="element-56">
            {timeLeft.hours.toString().padStart(2, '0')}
          </div>
          <div className="text-xs uppercase" data-id="element-57">Hours</div>
        </div>
        <div className="text-2xl font-bold mt-1" data-id="element-58">:</div>
        <div className="bg-red-600 text-white p-2 rounded-lg w-20 shadow-sm" data-id="element-59">
          <div className="text-3xl font-bold" data-id="element-60">
            {timeLeft.minutes.toString().padStart(2, '0')}
          </div>
          <div className="text-xs uppercase" data-id="element-61">Minutes</div>
        </div>
        <div className="text-2xl font-bold mt-1" data-id="element-62">:</div>
        <div className="bg-red-600 text-white p-2 rounded-lg w-20 shadow-sm" data-id="element-63">
          <div className="text-3xl font-bold" data-id="element-64">
            {timeLeft.seconds.toString().padStart(2, '0')}
          </div>
          <div className="text-xs uppercase" data-id="element-65">Seconds</div>
        </div>
      </div>
    </div>;
};
export default CountdownTimer;